import { render, staticRenderFns } from "./GlobalViolationsReport.vue?vue&type=template&id=2048b37d&scoped=true&"
import script from "./GlobalViolationsReport.vue?vue&type=script&lang=js&"
export * from "./GlobalViolationsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2048b37d",
  null
  
)

export default component.exports